export default __webpack_public_path__ + "static/media/single-project-page-02-img6.8218a53e.jpg";